// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DEVELOPMENT COMPANIES ||============================== //

export async function handleDevelopmentCompanies(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest(`/development-companies/list${action.data.dcIds ? `?dc-ids=${action.data.dcIds}` : ''}`);
    case 'list-v2':
      return getRequest(
        `/development-companies/list-v2${
          action.data.trialExcl
            ? `?trial-excl=true${action.subData.countries ? `&countries=${action.subData.countries}` : ''}`
            : action.data.dcIds
            ? `?dc-ids=${action.data.dcIds}&catalogues=${encodeURIComponent(action.data.catalogues)}`
            : `?catalogues=${encodeURIComponent(action.data.catalogues)}`
        }`
      );
    case 'list-v3': {
      const params = new URLSearchParams();

      if (action.data?.trialExcl) {
        params.set('trial-excl', 'true');
        if (action.subData?.countries) params.set('countries', action.subData.countries);
      } else {
        if (action.data?.dcIds) params.set('dc-ids', action.data.dcIds);
        if (action.data?.catalogues) params.set('catalogues', action.data.catalogues);
      }

      // requerido por backend
      if (action.subData?.agentId) params.set('agent-id', action.subData.agentId);

      const qs = params.toString();
      return getRequest(`/development-companies/list-v3${qs ? `?${qs}` : ''}`);
    }
    case 'list-special': {
      const params = new URLSearchParams();

      if (action.data?.trialExcl) {
        params.set('trial-excl', 'true');
        if (action.subData?.countries) params.set('countries', action.subData.countries);
      } else {
        if (action.data?.dcIds) params.set('dc-ids', action.data.dcIds);
        if (action.data?.catalogues) params.set('catalogues', action.data.catalogues);
      }

      // requerido por backend
      if (action.subData?.agentId) params.set('agent-id', action.subData.agentId);

      const qs = params.toString();
      return getRequest(`/development-companies/list-special${qs ? `?${qs}` : ''}`);
    }
    case 'list-mini':
      return getRequest('/development-companies/mini');
    case 'list-mini-v2':
      return getRequest('/development-companies/mini-v2');
    case 'create':
      return postRequest('/development-companies', action.data);
    case 'update':
      return putRequest(`/development-companies/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/development-companies/${action.id}`);
    case 'people':
      return getRequest(`/development-companies/${action.id}/people`);
    case 'developments':
      return getRequest(`/development-companies/${action.id}/developments-agent${action.data.dcIds ? `?dc-ids=${action.data.dcIds}` : ''}`);
    // case 'developments-v2':
    //   return getRequest(
    //     `/development-companies/${action.id}/developments-agent-v2${
    //       action.data.trialExcl
    //         ? '?trial-excl=true'
    //         : action.data.dcIds
    //         ? `?dc-ids=${action.data.dcIds}&catalogues=${encodeURIComponent(action.data.catalogues)}`
    //         : `?catalogues=${encodeURIComponent(action.data.catalogues)}`
    //     }`
    //   );
    case 'developments-v2': {
      const baseUrl = `/development-companies/${action.id}/developments-agent-v2`;

      const params = new URLSearchParams();

      // Mantener la lógica original:
      // - Si trialExcl => solo trial-excl
      // - Si NO trialExcl:
      //     - Si hay dcIds => dc-ids + catalogues
      //     - Si no hay dcIds => solo catalogues
      if (action.data.trialExcl) {
        params.set('trial-excl', 'true');
      } else {
        if (action.data.dcIds) {
          params.set('dc-ids', action.data.dcIds);
        }
        if (action.data.catalogues) {
          params.set('catalogues', action.data.catalogues);
        }
      }

      // Nuevo: agent-id (si lo tienes disponible en action.data.agentId)
      if (action.data.agentId) {
        params.set('agent-id', String(action.data.agentId));
      }

      const queryString = params.toString();
      const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

      return getRequest(url);
    }
    case 'developments-carousel-v2': {
      const baseUrl = `/development-companies/${action.id}/developments-carousel-v2`;
      const params = new URLSearchParams();

      if (action.data?.language) params.set('language', action.data.language);

      const queryString = params.toString();
      return getRequest(`${baseUrl}${queryString ? `?${queryString}` : ''}`);
    }
    case 'read-restrictions':
      return getRequest(`/development-companies/${action.id}/restrictions`);
    case 'update-restrictions':
      return putRequest(`/development-companies/${action.id}/restrictions`, action.data);
    case 'update-management':
      return putRequest(`/development-companies/${action.id}/management`, action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleDevelopmentCompanies] - Unknown method');
      break;
  }
}
